import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';

import colors from 'shared/modules/common/constants/colors';
import typography from 'shared/modules/common/constants/typography';

type Props = {
  isPayNowEnabled: boolean;
  isPlusWithApple: boolean;
};

export default function InfoContent({
  isPayNowEnabled,
  isPlusWithApple,
}: Props) {
  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      style={styles.scrollContainer}
    >
      <Text style={styles.sectionTitle}>ご利用総額</Text>
      <Text style={styles.sectionText}>
        {
          '今後お支払いいただくご利用金額の総額です。ご利用総額には以下のものを含みます。\n\n・翌月一括あと払い \n・3・6・12回あと払いの月々のお支払い \n・未確定のご利用 \n・キャッシュバックや返金などの払い戻し'
        }
      </Text>
      {isPlusWithApple && (
        <>
          <Text style={styles.sectionTitle}>Apple利用総額</Text>
          <Text style={styles.sectionText}>
            ペイディあと払いプランApple専用について、分割払いで今後お支払いいただく月々の金額の総額です。
          </Text>
        </>
      )}

      {/* Instant Payment section */}

      {isPayNowEnabled && (
        <>
          <Text style={styles.sectionTitle}>すぐ払い可能額</Text>
          <Text style={styles.sectionText}>
            当月分のご利用のうち、事前にコンビニで今すぐお支払いいただける金額です。お支払い期限を過ぎたご請求がある場合は、その金額も含まれます。
          </Text>

          <Text style={styles.sectionTitle}>「すぐ払い」</Text>
          <Text style={styles.sectionText}>
            {'ご利用開始のお知らせ\n\n'}
            {
              'ご利用金額の一部を、当月中にコンビニで支払い可能な「すぐ払い」のご利用を開始しました。翌月のご請求を待たすに支払えるので、ペイディをより便利で賢くお使いいただけます。\n\n'
            }
            {
              '※「すぐ払い」でお支払い後は、３回あと払いに変更することはできません。\n\n'
            }
            {
              '※ 口座振替（自動引き落とし）をご利用中のお客様は、「すぐ払い」をご利用いただけません。月末に口座振替から、コンビニ払いまたは銀行振込に変更して「すぐ払い」を利用した場合、翌月に重複して引き落としが発生する場合があります。月末の変更および「すぐ払い」のご利用は、なるべくお控えください。\n\n'
            }
            {
              '※３回あと払いの2回目および3回目の金額は、1日から5日までの「すぐ払い可能額」に反映されていない場合がありますので、ご注意ください。'
            }
          </Text>
        </>
      )}
      <Text style={styles.sectionTitle}>未確定</Text>
      <Text style={styles.sectionText}>
        販売店からペイディに請求情報が届いていない未確定のご利用が表示されます。ペイディに請求情報が届いた時点でご利用確定となり、「ご利用確定のお知らせ」メールが送信され、「ご利用履歴」に反映されます。
      </Text>
      <Text style={styles.sectionTitle}>ご利用履歴</Text>
      <Text style={styles.sectionText}>
        確定した当月のご利用が表示されます。
      </Text>
      <Text style={styles.sectionTitle}>お支払い履歴</Text>
      <Text style={styles.sectionText}>
        {`毎月のご請求のお支払いの履歴が表示されます。\n\n※銀行振込でのお支払いの表示について \n\n・お支払い金額とご請求金額が同額の場合「●年●月分（お支払い済み）」と表示されます。\n\n・お支払い金額とご請求金額が異なる場合「銀行振込」と表示されます。`}
      </Text>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  sectionTitle: {
    ...typography.bodyBold,
    color: colors.black,
  },
  sectionText: {
    ...typography.body,
    fontWeight: '400',
    marginTop: 8,
    marginBottom: 24,
  },
  scrollContainer: {
    flex: 1,
  },
});
